import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  private allowedKeys = [
    'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete',
    'Home', 'End', 'Enter', 'Shift', 'Control'
  ];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;

    if (
      this.allowedKeys.includes(event.key) ||
      isCtrlOrCmd
    ) {
      return;
    }




    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData?.getData('text') || '';

    // Allow pasting only if clipboard data contains numbers
    if (!/^\d+$/.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
